import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "docs-logo"
    }}><img parentName="h1" {...{
        "src": "https://contrast.now.sh/white/black?width=80&height=40&text=DOCS",
        "alt": "Docs Logo"
      }}></img></h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/johno/gatsby-theme-documentation"
        }}>{`GitHub`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://twitter.com/4lpine"
        }}>{`Twitter`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      